import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn, staggerContainer, staggerItem } from './ui/FadeIn';
import { Heart } from 'lucide-react';
const audiences = ['Madres solteras que sienten que llevan el peso del mundo solas.', 'Mujeres emigrantes que están construyendo un hogar sin red de apoyo familiar.', 'Mamás que sospechan o saben que tienen TDAH y se sienten abrumadas por la rutina.', "Cualquier mujer que sienta que vive en 'piloto automático' y necesita volver a sentirse ella misma."];
export function TargetAudience() {
  return <section className="py-24 bg-cream-alt" data-id="element-124">
      <div className="max-w-4xl mx-auto px-6 md:px-8" data-id="element-125">
        <FadeIn className="text-center mb-16" data-id="element-126">
          <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-127">
            ¿Para Quién Es Esto?
          </h2>
          <div className="w-16 h-1 bg-sage mx-auto rounded-full opacity-50" data-id="element-128" />
        </FadeIn>

        <motion.div variants={staggerContainer} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-100px'
      }} className="space-y-6" data-id="element-129">
          {audiences.map((text, index) => <motion.div key={index} variants={staggerItem} className="flex items-center gap-6 p-6 bg-cream rounded-2xl shadow-sm border border-warm-deep/30" data-id="element-130">
              <div className="flex-shrink-0 text-sage/80" data-id="element-131">
                <Heart size={28} fill="currentColor" data-id="element-132" />
              </div>
              <p className="text-lg md:text-xl text-brown-light leading-relaxed" data-id="element-133">
                {text}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}